import React, { memo } from 'react';
import DeleteAccountGuard from '../navigation/DeleteAccountGuard';
import { RouteModalComponent } from '../navigation/Modals';

const DeleteAccount: RouteModalComponent = () => <DeleteAccountGuard />;

export default memo(DeleteAccount);
